import React from 'react'

import { Spinner } from '@acorns/web-components'
import { compose, withHandlers, withState } from 'recompose'
import styled from 'styled-components'

import OpenExternalIcon from 'assets/icons/open-external.png'

type Props = {
  src: string
}

type StateProps = {
  iFrameLoading: boolean
  setIFrameLoading: (iFrameLoaded: boolean) => void
}
type HandlerProps = {
  onIFrameLoaded: () => void
}

export type AgreementDocProps = Props & HandlerProps & StateProps

const MainContainer = styled.div`
  position: relative;
  height: calc(100% - 66px);
  z-index: 20;
`

const Container = styled.div`
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
  margin: 0;
  z-index: 22;

  > iframe {
    width: 100%;
    height: 100%;
    border: 0;
    overflow-y: hidden;
    margin: 0;
    padding: 0;
    z-index: 24;
  }
`

const OpenExternal = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0.5;
  z-index: 30;
`

const Centered = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const enhance = compose(
  withState('iFrameLoading', 'setIFrameLoading', true),
  withHandlers({
    onIFrameLoaded: ({ setIFrameLoading }) => () => {
      setIFrameLoading(false)
    },
  }),
)

const AgreementDoc: React.SFC<AgreementDocProps> = ({ src, onIFrameLoaded, iFrameLoading }) => (
  <MainContainer>
    <OpenExternal>
      <a href={src} target="_blank" rel="noreferrer">
        <img src={OpenExternalIcon} width="24px" height="24px" alt="Open agreement in new window" />
      </a>
    </OpenExternal>
    <Container>
      {iFrameLoading && (
        <Centered>
          <Spinner />
        </Centered>
      )}
      <iframe
        id="agreementdoc"
        title="agreementdoc"
        src={src}
        data-testid={'agreement_doc_iframe'}
        scrolling="yes"
        onLoad={onIFrameLoaded}
      />
    </Container>
  </MainContainer>
)

export default enhance(AgreementDoc)
